// extracted by css-extract-rspack-plugin
export default {"container":"src-wab-client-components-sidebar-tabs-ServerQuery-ServerQueryOpPicker-module__container-Sv3SU8"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"container\":\"src-wab-client-components-sidebar-tabs-ServerQuery-ServerQueryOpPicker-module__container-Sv3SU8\"}";
        // 1793541993656
        var cssReload = require("../../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  